export const COOKIE_MAX_AGE_1_YEAR = 365 * 24 * 60 * 60
export const TOKEN_KEY = 'hodor-access-token'
export const USER_DATA_KEY = 'hodor-user-data'